<h2 mat-dialog-title>Doppelte Positionsnummern gefunden</h2>

<div mat-dialog-content class="duplicate-positions-content">
    <div class="column">
        <h3>Ausgewählt</h3>
        <ul>
            <li *ngFor="let arl of data.selected">
                <span class="item-number">{{ arl.ItemNumber }}</span>
                <span class="bezeichnung">{{ arl.Bezeichnung }}</span>
            </li>
        </ul>
    </div>

    <div class="column">
        <h3>Bestehende Positionen</h3>
        <ul>
            <li *ngFor="let arl of data.existing">
                <span class="item-number">{{ arl[0] }}</span>
                <span class="bezeichnung">{{ arl[1] }}</span>
            </li>
        </ul>
    </div>
</div>

<div mat-dialog-actions class="duplicate-positions-actions">
    <button app-button Inverted  Color="cancel" (click)="cancel()">
        Abbrechen
    </button>

    <div class="right-actions">
        <div class="action-with-hint">
            <button app-button Color="green" (click)="forceTakeOver()">
                trotzdem übernehmen
            </button>
            <app-hint-icon
                hint="Die Positionsnummern der neuen Positionen werden dadurch neu ausgerechnet">
            </app-hint-icon>
        </div>

        <div class="action-with-hint">
            <button [Disabled]="data.disableOkButton" app-button Color="green" (click)="ok()">
                Ok
            </button>
            <app-hint-icon
                hint="Duplikate werden nicht übernommen">
            </app-hint-icon>
        </div>
    </div>
</div>
